export default {
    'api_url': 'https://chat.cdo.org.ua/api/v.1/',
    'public_base': '/static/front-end/public',
    'socket_url': 'https://ws.chat.cdo.org.ua/chat',
    'socket_url2': 'https://ws.chat.cdo.org.ua/counter',
    'base_url': 'https://chat.cdo.org.ua',
    'media_url': 'https://chat.cdo.org.ua/media',
    's3_url': 'https://s3.eu-central-1.amazonaws.com/cdo-prod-bucket/',
	'moodle_login_url': 'https://edu.cdo.org.ua/login/index.php',
    'sentry_dsn': 'https://c80cbf28087849e7966ee619c1d35956@o463598.ingest.sentry.io/5473152',
    'viber_bot_url': 'viber://pa?chatURI=cdoorgua_bot&context=user_id=',
    'telegram_bot_url': "https://t.me/cdoorgua_bot/?start=user_id=",
    'moodle_login_urls': {
        '2': 'https://edu.cdo.org.ua/login/index.php',
        '5': 'https://demo.cdo.org.ua/login/index.php',
        '7': 'https://listener.cdo.org.ua/login/index.php',
    },
    'params': {
        '2': {
            'name': 'jerelo',
            'show_moodle': false,
            'show_courses_button': false,
            'show_courses_button_teacher': true,
            'show_courses_button_student': true,
            'show_courses_button_biller': false,
            'show_courses_button_admin': true,
            'show_courses_button_moderator': true,
            'show_courses_button_student_billing': true,
            'sourcelms': false,
            'show_question_button': true,
        },
        '5': {
            'name': 'demo',
            'show_moodle': false,
            'show_courses_button': false,
            'show_courses_button_teacher': true,
            'show_courses_button_student': true,
            'show_courses_button_biller': false,
            'show_courses_button_admin': true,
            'show_courses_button_moderator': true,
            'show_courses_button_student_billing': true,
            'sourcelms': true,
       },
        '7': {
            'name': 'listener',
            'show_moodle': true,
            'show_courses_button': false,
            'show_courses_button_teacher': true,
            'show_courses_button_student': false,
            'show_courses_button_biller': false,
            'show_courses_button_admin': true,
            'show_courses_button_moderator': true,
            'show_courses_button_student_billing': false,
            'sourcelms': false,
        },
        '8': {
            'name': 'jerelo_plus',
            'show_moodle': false,
            'show_courses_button': true,
            'show_courses_button_teacher': true,
            'show_courses_button_student': true,
            'show_courses_button_biller': false,
            'show_courses_button_admin': true,
            'show_courses_button_moderator': true,
            'show_courses_button_student-biller': true,
            'sourcelms': false,
            'show_question_button': true,
        }
    }
}

